import { Component, OnInit } from '@angular/core';
import {UserPrivilegeService} from '../../../services/common/user-privilege/user-privilege.service';
import {NetworkLayersService} from '../../../network/services/map/network-layers/network-layers.service';
import {LicenseFeaturesService} from '../../../services/common/license-features/license-features.service';
import {LoaderService} from '../../../services/common/loader-service/loader.service';
import {
  QualityBasedRoutingApiService
} from '../../../services/api/settings/routing/quality-based-routing/quality-based-routing-api.service';

@Component({
  selector: 'quality-based-routing',
  templateUrl: './quality-based-routing.component.html',
  styleUrls: ['./quality-based-routing.component.scss']
})
export class QualityBasedRoutingComponent implements OnInit {

  isQBRLicenseEnabled: boolean;
  canSubmit = false;
  mosSliderOptions: any = {floor: 1, ceil: 5, step: 0.1, precision: 1};
  asrSliderOptions: any = {floor: 0, ceil: 100, step: 1, translate(value): any {return value + '%'; }};
  qualityBasedRoutingSettings: any;

  constructor(private userPrivilege: UserPrivilegeService,
              private qualityBasedRoutingApiService: QualityBasedRoutingApiService,
              private networkLayersService: NetworkLayersService,
              private licenseFeaturesService: LicenseFeaturesService,
              private loaderService: LoaderService) {
  }

  ngOnInit(): void {
    this.loaderService.showMainContainer();
    this.licenseFeaturesService.isFeatureSupported(
      'qbr').subscribe(isFeatureSupported => {
      this.isQBRLicenseEnabled = isFeatureSupported;
      this.canSubmit = this.userPrivilege.isAuthorized() && this.isQBRLicenseEnabled;
    });

    this.initializeQualityBasedRoutingConfigurations();
  }

  initializeQualityBasedRoutingConfigurations(): void {
    this.qualityBasedRoutingApiService.getQualityBasedRoutingSettings().subscribe(qualityBasedRoutingSettings => {
      this.qualityBasedRoutingSettings = qualityBasedRoutingSettings;
      this.updateSlidersOptions(undefined);
      this.loaderService.hideMainContainer();
    });
  }

  updateSlidersOptions(qosType: string): void {
    const updateMosOptions = () => {
      this.mosSliderOptions = Object.assign({}, this.mosSliderOptions,
        {disabled: !(this.qualityBasedRoutingSettings.isQualityEnabled && this.qualityBasedRoutingSettings.qualityConf.MOS.isUsed)});
    };
    const updateAsrOptions = () => {
      this.asrSliderOptions = Object.assign({}, this.asrSliderOptions,
        {disabled: !(this.qualityBasedRoutingSettings.isQualityEnabled && this.qualityBasedRoutingSettings.qualityConf.ASR.isUsed)});
    };

    switch (qosType) {
      case 'mos': {
        updateMosOptions();
        break;
      }
      case 'asr': {
        updateAsrOptions();
        break;
      }
      default: {
        updateMosOptions();
        updateAsrOptions();
        break;
      }
    }
  }

  submit(): void {
    this.qualityBasedRoutingApiService.editQualityBasedRoutingSettings(this.qualityBasedRoutingSettings).subscribe(data => {
      if (!data.isQualityEnabled) {
        this.networkLayersService.setSelectedLayers({
          topology: true,
          quality: false
        });
      }
    });
  }
}
